import { gbConstants } from "../_constants";
import { authHeader } from "../_helpers";

export const chartService = {
    getCharts
};

const chartURL = `${gbConstants.HOST_SERVICE}/v1.1/chart/getAll`;
function date(date){
	let d = date.split("/")
	return d[2]+'-'+d[1]+'-'+d[0]
}

function getCharts(filter) {
    const requestOptions = {
        mode: "cors",
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify({
        	campId : filter.campaignID,
        	beginDate : date(filter.startDate),
        	endDate : date(filter.endDate)
        }),
    };
    return fetch(chartURL, requestOptions)
        .then(response => {
            if (!response.ok) {
                return Promise.reject(response.statusText);
            }
            return response.json();
        })
        .then(data => {
           
            if (
                data.error &&
                data.error.code &&
                data.error.code !== 200 &&
                data.error.message
            ) {
                return Promise.reject(data.error.message);
            }
            return data;
        });
}



// WEBPACK FOOTER //
// ./src/_services/chart.service.js